<template>
    <div class="redeem-container" v-report.pv="{f_module:'主页面'}">
        <userInfo></userInfo>
        <redeem></redeem>
        <instruction></instruction>
    </div>
</template>

<script type="text/ecmascript">
import { mapActions } from 'vuex';

import env from '@tencent/vft-common/env';
import login from '@tencent/wetv-common/login';

import instruction from 'src/components/mod-instruction.vue';
import redeem from 'src/components/mod-redeem.vue';
import userInfo from 'src/components/user-info.vue';

export default {
  name: 'redeem-container',
  components: {
    userInfo,
    redeem,
    instruction,
  },
  computed: {
    langSwitchVisible() {
      return !env.isWetv;
    },
  },
  async created() {
    await this.$store.dispatch('getAppInfo');
    if (login.isLogin()) {
      this.$store.dispatch('getUserInfo');
    }
    // 登录态变化时，更新页面数据
    login.onLogin(() => {
      this.$store.dispatch('getUserInfo');
      this.resetIsLogin(true);
    });
    login.onLogout(() => {
      this.$store.dispatch('getUserInfo');
      this.resetIsLogin(false);
    });
  },
  methods: {
    ...mapActions(['resetIsLogin']),
  },
};
</script>
